import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    TextField,
    Slide,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@iconify/react/dist/iconify.js';
import SearchableDropdown from '../../../../components/SearchableDropdown';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const TYPE_OPTIONS = [
    { value: 'admin', label: 'Admin' },
    { value: 'super', label: 'Super Admin' },
];

const initialState = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    password: '',
    type: 'admin',
};

const AddAdminUserModal = ({ open, onClose }) => {
    const [formData, setFormData] = useState(initialState);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (open) setFormData(initialState);
    }, [open]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (!formData.first_name || !formData.email || !formData.password) {
            alert('Please fill all required fields');
            return;
        }
        setIsLoading(true);
        try {
            console.log('Adding admin user:', formData);
            await new Promise((resolve) => setTimeout(resolve, 800));
            onClose();
        } catch (error) {
            console.error('Error adding admin user:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                }
            }}
        >
            <DialogTitle sx={{ p: 0 }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 2.5,
                        py: 2,
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '1rem' }}>
                        Add New Admin User
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        size="small"
                        disabled={isLoading}
                        sx={{
                            color: 'text.secondary',
                            '&:hover': { backgroundColor: 'action.hover' },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent
                sx={{
                    px: 2.5,
                    pb: 2,
                    '&.MuiDialogContent-root': { paddingTop: '20px' },
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#e11d48',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: '#e11d48',
                    },
                }}
            >
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1.75, mt: 0.5 }}>
                    <TextField
                        fullWidth
                        label="First Name"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleInputChange}
                        required
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        fullWidth
                        label="Last Name"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleInputChange}
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        fullWidth
                        label="Phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        fullWidth
                        label="Password"
                        name="password"
                        type="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        required
                        variant="outlined"
                        size="small"
                    />
                    <Box>
                        <SearchableDropdown
                            value={formData.type}
                            onChange={(v) => handleInputChange({ target: { name: 'type', value: v } })}
                            options={TYPE_OPTIONS}
                            placeholder="Role Type"
                            clearable={false}
                            small
                        />
                    </Box>
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 2.5, py: 2, borderTop: '1px solid', borderColor: 'divider', gap: 1.5 }}>
                <button
                    type="button"
                    className="btn btn-outline-secondary radius-8 px-20 py-10 text-sm fw-medium d-inline-flex align-items-center justify-content-center gap-2"
                    onClick={onClose}
                    disabled={isLoading}
                    style={{ flex: 1 }}
                >
                    <Icon icon="solar:close-circle-outline" />
                    <span>Cancel</span>
                </button>
                <button
                    type="button"
                    className="btn radius-8 px-20 py-10 text-sm fw-medium text-white d-inline-flex align-items-center justify-content-center gap-2"
                    onClick={handleSubmit}
                    disabled={isLoading}
                    style={{ flex: 1, backgroundColor: '#e11d48', borderColor: '#e11d48' }}
                >
                    {isLoading ? (
                        <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span>Adding...</span>
                        </>
                    ) : (
                        <>
                            <Icon icon="solar:add-circle-bold" />
                            <span>Add Admin</span>
                        </>
                    )}
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default AddAdminUserModal;
